import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FulfillmentOrderStatus } from '@vendasta/order-fulfillment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WorkOrderPersona } from '../work-order-landing-page/interfaces';

export interface WorkOrderSalesOrderSummaryInfo {
  appName: string;
  appIconUrl?: string;
  workOrderId: string;
  workOrderStatus: FulfillmentOrderStatus;
  workOrderLandingPageUrl?: string;
  workOrderLandingPageRouterLinkUrl?: string;
  hasForm?: boolean;
}

/**
 * Provides a summary of work orders related to a specific sales order.
 * Shows different information based on viewing Persona
 */
@Component({
  selector: 'work-order-sales-order-summary',
  templateUrl: './work-order-sales-order-summary.component.html',
  styleUrls: ['./work-order-sales-order-summary.component.scss'],
})
export class WorkOrderSalesOrderSummaryComponent implements OnInit {
  @Input() workOrders: WorkOrderSalesOrderSummaryInfo[] = [];
  @Input() includeThermometer = false;
  @Input() persona: WorkOrderPersona = WorkOrderPersona.VENDOR;
  thermometerProgress = 0;
  thermometerSuffix: string;
  isMobile$: Observable<boolean>;
  isVendor: boolean;

  constructor(
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.isVendor = this.persona === WorkOrderPersona.VENDOR;
    this.isMobile$ = this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(map((bp) => bp.matches));
    if (this.includeThermometer) {
      const completed = this.workOrders.reduce(
        (prev, curr) =>
          curr.workOrderStatus === FulfillmentOrderStatus.FULFILLMENT_ORDER_STATUS_COMPLETED ? prev + 1 : prev,
        0,
      );
      const total = this.workOrders.length;
      this.thermometerProgress = 100 * (completed / total);
      this.thermometerSuffix = this.translateService.instant('SALES_ORDER_SUMMARY.THERMOMETER_SUFFIX', {
        completed,
        total,
      });
    }
  }

  handleChevronClick(wo: WorkOrderSalesOrderSummaryInfo): void {
    if (wo?.workOrderLandingPageRouterLinkUrl) {
      this.router.navigate([wo.workOrderLandingPageRouterLinkUrl], {
        relativeTo: this.route,
        fragment: wo.workOrderId,
      });
    } else if (wo?.workOrderLandingPageUrl) {
      window.open(wo.workOrderLandingPageUrl, '_blank', 'noopener');
    }
  }
}
